import {IUser} from 'MyModels';
import {createSelector} from 'reselect';
import {RootState} from 'typesafe-actions';
import IInfo = MyTypes.IInfo;
import {AuthState} from './reducer';

const authSelector = (state: RootState): AuthState => state.auth;

export const getUser = createSelector<any, any, IUser | null>(
  authSelector,
  (auth: AuthState) => auth.user
);

export const getInfo = createSelector<any, any, IInfo>(
  authSelector,
  (auth: AuthState) => auth.info
);



// WEBPACK FOOTER //
// ./src/features/auth/store/selectors.ts